import React from 'react';
import { Grid } from '@mui/material';
import { useGetPaginatedOpportunitiesQuery } from '../../Redux/Service/OpportunityApi';
import Loading from '../../Components/Loading';
import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Search } from '../../Components';
import StyledDashboardLayout from '../style';
export default function OpportunityList() {
   const [loading, setLoading] = useState(true);
   const [estimationData, setEstimationData] = useState(null);
   const [searchQuery, setSearchQuery] = useState('');
   const [page, setPage] = useState(1);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const {
      data: Oppertunities,
      refetch,
      isLoading,
      isError,
      error,
   } = useGetPaginatedOpportunitiesQuery({
      limit: rowsPerPage,
      page: page,
      orderBy: 'DESC',
      search: searchQuery,
   });

   const customStyles = {
      rows: {
         style: {
            margin: '0px',
            padding: 0,
            '@media (max-width: 768px)': {
               padding: '5px 0', // Adjust row padding for smaller screens
            },
         },
      },
      headCells: {
         style: {
            margin: '0px',
            padding: '10px 15px',
            fontWeight: 600,
            fontSize: '16px',
            background: '#3F30FF1A',
            '@media (max-width: 768px)': {
               fontSize: '14px', // Smaller font size for mobile
               padding: '8px 10px', // Less padding for mobile
            },
         },
      },
      cells: {
         style: {
            margin: '0px',
            padding: '10px 15px',
            fontSize: '15px',
            fontWeight: 400,
            color: '#726E6E',
            '@media (max-width: 768px)': {
               fontSize: '14px', // Smaller font size for mobile
               padding: '8px 10px', // Less padding for mobile
            },
         },
      },
   };

   useEffect(() => {
      refetch();
   }, [refetch, searchQuery]);

   useEffect(() => {
      if (!isLoading && !isError) {
         setEstimationData(Oppertunities?.response);
         setLoading(false);
      }
   }, [isLoading, isError, Oppertunities]);

   const handleSearch = (search) => {
      setSearchQuery(search);
      setPage(1);
   };

   const columns = [
      {
         name: 'SL No',
         cell: (row, index) => index + 1,
         width: '120px',
         minWidth: '120px',
      },
      {
         name: 'Name',
         selector: (row) => row.name,
         sortable: true,
         minWidth: '300px',
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.name}</div>
         ),
      },
      {
         name: 'Account',
         selector: (row) => row.account,
         sortable: true,
         minWidth: '150px',
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.account}</div>
         ),
      },
      {
         name: 'Stage',
         selector: (row) => row.stage,
         sortable: true,
         minWidth: '100px',
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.stage}</div>
         ),
      },
      {
         name: 'Assigned User',
         selector: (row) => row.asignedUser,
         sortable: true,
         minWidth: '160px',
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.asignedUser}</div>
         ),
      },
      {
         name: 'Amount',
         selector: (row) => row.amount,
         sortable: true,
         minWidth: '100px',
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.amount}</div>
         ),
      },
      {
         name: 'Currency',
         selector: (row) => row.currency,
         sortable: true,
         minWidth: '80px',
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.currency}</div>
         ),
      },
      {
         name: 'Created At',
         selector: (row) => new Date(row.createdAt).toLocaleString(),
         sortable: true,
         minWidth: '160px',
      },
   ];

   if (loading) {
      return <Loading />;
   }

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header">
               <div className="container-fluid">
                  <div className="d-flex justify-content-between mb-2">
                     <div className="pageTitle">
                        <h1 className="m-0">Opportunities</h1>
                     </div>
                     <div className="">
                        {/* <Link to="/estimate-add" className="btn btn-dark"><DocumentScannerIcon /> Add Estimation</Link> */}
                     </div>
                  </div>
               </div>
            </div>
            <div className="card m-3 customCard">
               {isLoading ? (
                  <div>Loading...</div>
               ) : isError ? (
                  <div>Error: {error?.message}</div>
               ) : (
                  <div>
                     <Grid container spacing={2}>
                        <Grid item md={6} xs={12}></Grid>
                        <Grid item md={6} xs={12} display="flex" justifyContent="flex-end">
                           <Search onSearch={(query) => handleSearch(query)} />
                        </Grid>
                     </Grid>

                     <DataTable
                        columns={columns}
                        data={estimationData.data}
                        pagination
                        paginationServer
                        paginationTotalRows={estimationData.pagination.total}
                        paginationDefaultPage={page}
                        paginationPerPage={rowsPerPage}
                        onChangePage={setPage}
                        onChangeRowsPerPage={(newPerPage) => {
                           setRowsPerPage(newPerPage);
                           setPage(1);
                        }}
                        customStyles={customStyles}
                        className="dataTable"
                     />
                  </div>
               )}
            </div>
         </div>
      </StyledDashboardLayout>
   );
}
